import { alpha } from "@mui/material/styles";

export const premiumAutocompleteSx = (theme) => ({
    "& .MuiAutocomplete-popper": {
        zIndex: 1500,
    },

    "& .MuiAutocomplete-paper": {
        mt: 1,
        borderRadius: 18,
        overflow: "hidden",
        border: `1px solid ${alpha(theme.palette.divider, theme.palette.mode === "dark" ? 0.35 : 0.6)}`,
        boxShadow:
            theme.palette.mode === "dark"
                ? "0 22px 70px rgba(0,0,0,0.55)"
                : "0 22px 70px rgba(0,0,0,0.18)",
        background:
            theme.palette.mode === "dark"
                ? `linear-gradient(180deg,
            ${alpha(theme.palette.background.paper, 0.92)},
            ${alpha(theme.palette.background.default, 0.86)}
          )`
                : `linear-gradient(180deg,
            ${alpha("#ffffff", 0.98)},
            ${alpha(theme.palette.primary.light, 0.08)}
          )`,
        backdropFilter: "blur(10px)",
    },

    "& .MuiAutocomplete-listbox": {
        padding: 10,
        maxHeight: 360,
    },
});

/**
 * option styling (row)
 * NOTE: παίρνει και index για zebra striping
 */
export const premiumOptionSx = (theme, index = 0) => {
    const isDark = theme.palette.mode === "dark";
    const zebra = index % 2 === 0;

    const baseBg = zebra
        ? alpha(theme.palette.primary.main, isDark ? 0.06 : 0.05)
        : alpha(theme.palette.secondary.main, isDark ? 0.05 : 0.04);

    return {
        px: 1.5,
        py: 1.1,
        borderRadius: 14,
        mx: 0.5,
        my: 0.6,
        display: "flex",
        alignItems: "center",
        gap: 1,
        fontWeight: 800,
        cursor: "pointer",
        backgroundColor: baseBg,
        border: `1px solid ${alpha(theme.palette.divider, isDark ? 0.18 : 0.26)}`,
        transition: "transform 140ms ease, background 140ms ease, box-shadow 140ms ease, border 140ms ease",

        "&.Mui-focused, &[aria-selected='true']": {
            backgroundColor: alpha(theme.palette.primary.main, isDark ? 0.16 : 0.12),
            border: `1px solid ${alpha(theme.palette.primary.main, isDark ? 0.42 : 0.35)}`,
            boxShadow: `0 10px 22px ${alpha(theme.palette.primary.main, isDark ? 0.18 : 0.12)}`,
        },

        "&:hover": {
            transform: "translateX(2px)",
            backgroundColor: alpha(theme.palette.primary.main, isDark ? 0.18 : 0.14),
            border: `1px solid ${alpha(theme.palette.primary.main, isDark ? 0.45 : 0.35)}`,
            boxShadow: `0 14px 26px ${alpha(theme.palette.primary.main, isDark ? 0.20 : 0.12)}`,
        },
    };
};
